module.exports = __webpack_public_path__ + "img/IMAG2697.de21a613.jpg";